import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
// import { ToastrModule } from 'ngx-toastr';

import { ValidationMessagesComponent } from './validation-message.component';
import { EqualValidator } from './equal-validator.directive';
import { NotificationService } from './notification.service';
import { WindowService } from './window.service';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateLanguageLoader, AppTranslationService } from '../app-translation.service';
import { ProfilePictureService } from './profile-picture.service';
import { ButtonBusyDirective } from './button-busy.directive';
import { ChangePasswordComponent } from './change-password.component';
import { ChatComponent } from './chat.component';
import { FormsModule } from '@angular/forms';
import { EmailAlreadyExistDirective } from './email-exist-validator.directive';
import { TimeConverterPipe } from './stringToDateConverter.pipe';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateLanguageLoader
            }
        }),
        NgxSpinnerModule
    ],

    providers: [
        WindowService,
        DatePipe
    ],
    declarations: [
        EqualValidator,
        ButtonBusyDirective,
        ValidationMessagesComponent,
        ChangePasswordComponent,
        ChatComponent,
        EmailAlreadyExistDirective,
        TimeConverterPipe,
    ],
    exports: [
        EqualValidator,
        ButtonBusyDirective,
        ValidationMessagesComponent,
        TranslateModule,
        ChangePasswordComponent,
        ChatComponent,
        EmailAlreadyExistDirective,
        TimeConverterPipe,
        NgxSpinnerModule
    ]
})
export class UtilsModule { }
